import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatCentsToDollars',
    standalone: false,
    pure: true
})
export class FormatCentsToDollarsPipe implements PipeTransform {
  transform(cents: number, showDecimals = false): string {
    if (!cents && cents !== 0) {return '';}
    const dollars = cents / 100;
    return showDecimals ? `$${dollars.toFixed(2)}` : `$${dollars.toFixed(0)}`;
  }
}
